<template>
  <div class="d-flex justify-end" @click.shift="editRessource">
    <v-btn v-if="!isMobile && showExtendButtons" icon @click='closeAll'>
      <v-icon class="header-text" color="generalBtn">fas fa-angles-up</v-icon>
    </v-btn>
    <v-btn v-if="!isMobile && showExtendButtons" icon @click='openAll'>
      <v-icon class="header-text" color="generalBtn">fas fa-angles-down</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts">
  import { isMobile } from '@/style/StyleHelpers';
  import { MapRessource, type EditRessource } from '@/framework/base/helpers/Ressources';
  import { defineComponent, type PropType } from "vue";
  import { storeSession } from '@/generated/stores';
  import UserProfile, { EnumProfile } from '@/framework/base/classes/UserProfile';

  export let cbEditRessource: EditRessource | undefined = undefined;
  export function setEditRessource(editRessource: EditRessource) {
    cbEditRessource = editRessource;
  }
  export default defineComponent({
    props: {
      ressource: {
        type: Object as PropType<MapRessource>
      },
      picto: {
        type: String
      },
      showExtendButtons: {
        type: Boolean
      }
    },
    data() {
      return {
        isMobile: isMobile(),
        cbEditRessource
      };
    },
    methods: {
      closeModule() {
        this.$emit('back');
      },
      openAll(): void {
        this.$emit('openAll');
      },
      closeAll(): void {
        this.$emit('closeAll');
      },
      editRessource() {
        const user = storeSession.connectedUser;
        if (user) {
          const isAdmin = UserProfile.hasProfile(user, EnumProfile.admin);
          if (isAdmin && cbEditRessource && this.ressource) {
            cbEditRessource(this.ressource, this.updateResource);
          }
        }
      },
      updateResource(): void {
        debugger;
      }
    }
  })

</script>

<style scoped>
</style>
